import { render } from "./ClassTab.vue?vue&type=template&id=501ac946&scoped=true"
import script from "./ClassTab.vue?vue&type=script&lang=js"
export * from "./ClassTab.vue?vue&type=script&lang=js"

import "./ClassTab.vue?vue&type=style&index=0&id=501ac946&lang=scss&scoped=true"

import exportComponent from "/Users/zhanglinjun/Downloads/genescloud_wechat-master-d167e5133fddc18883d58aba5b516d53ee974944/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501ac946"]])

export default __exports__